import { render } from "./BookSuccessionList.vue?vue&type=template&id=56808a1f&scoped=true"
import script from "./BookSuccessionList.vue?vue&type=script&lang=js"
export * from "./BookSuccessionList.vue?vue&type=script&lang=js"

import "./BookSuccessionList.vue?vue&type=style&index=0&id=56808a1f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56808a1f"]])

export default __exports__